import { render } from "./ApiTest.vue?vue&type=template&id=749d456f"
import script from "./ApiTest.vue?vue&type=script&lang=ts"
export * from "./ApiTest.vue?vue&type=script&lang=ts"

import "./ApiTest.vue?vue&type=style&index=0&id=749d456f&lang=scss"
script.render = render

export default script
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QInput,QBtn});
